import {Injectable} from '@angular/core';
import {SaleInvoiceModel} from '../../api/entity/saleInvoice.model';
import {SaleInvoiceRepository} from '../../impl/service/ngrx/saleInvoice.repository';
import {AbstractFindOneByIdService} from '../../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {SaleInvoiceDataServiceAdapter} from '../../impl/service/ngrx/saleInvoiceDataService.adapter';

@Injectable()
export class SaleInvoiceFindOneByIdService extends AbstractFindOneByIdService<SaleInvoiceModel, SaleInvoiceModel> {

    constructor(repository: SaleInvoiceRepository,
                dataService: SaleInvoiceDataServiceAdapter) {
        super(repository, dataService);
    }
}
